<query-builder [(ngModel)]='data' [config]='config'   [operatorMap]="defaultOperatorMap"    [allowRuleset]="allowRuleset" >
  
  <ng-container *queryButtonGroup="let ruleset; let addRule=addRule; let addRuleSet=addRuleSet; let removeRuleSet=removeRuleSet">
    <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
      <button (click)="addRule()" [ngClass]="getClassNames('button')" class="k-button k-primary">
        <i class="fa fa-plus" aria-hidden="true"></i> Filter
      </button>

      <button (click)="addRuleSet()" [ngClass]="getClassNames('button')"  *ngIf="addRuleSet" class="k-button k-primary" >
        <i class="fa fa-plus" aria-hidden="true"></i> Filterset
      </button>
      <ng-container >
        <button [ngClass]="getClassNames('button', 'removeButton')"  *ngIf="removeRuleSet"  (click)="removeRuleSet()">
          <i [ngClass]="getClassNames('removeIcon')"></i>
        </button>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *queryRemoveButton="let rule; let removeRule=removeRule">
    <div [ngClass]="getClassNames('removeButtonSize', 'rightAlign')">
      <button [ngClass]="getClassNames('button', 'removeButton')" (click)="removeRule(rule)">
        <i [ngClass]="getClassNames('removeIcon')"></i>
      </button>
    </div>
  </ng-container>

  <ng-container *queryInput="let rule;  let options=options; type: 'category'">
    <div  [ngClass]="getClassNames('inputControl')" >
      <ng-select [searchWhileComposing] = "true" (search)="execKeypress($event,rule.field)" [searchable]="true"  [clearSearchOnAdd] = "true"  [loading]="loading"   [virtualScroll]="true"  
       bindLabel = "name"   [(ngModel)]="rule.value"  (scrollToEnd)="fetchMore(rule)" style="max-width:200%;width:200%;padding: 0px;min-width: 200px;">
        <ng-option *ngFor="let opt of getOptions(rule.field)" [value]="opt.value">{{opt.name}}</ng-option>
      </ng-select>
    
    </div>
  </ng-container>

  <ng-container *queryInput="let rule; let options=options; type: 'multiselect'; let onChange=onChange">
    <ng-select  [searchWhileComposing] = "true" (search)="execKeypress($event,rule.field)" [searchable]="true" [multiple] = "true" [clearSearchOnAdd] = "true" [loading]="loading"   [virtualScroll]="true"   (ngModelChange)="onChange()"
      [(ngModel)]="rule.value"  (scrollToEnd)="fetchMore(rule)" style="width:auto;padding: 0px;display: inline-block;" style="margin-left: 5px;
      width: 400px;
      padding: 0px;
      display: inline-block;
      height: 31px;">
      <ng-option *ngFor="let opt of getOptions(rule.field)"  [value]="opt.value">{{opt.name}}</ng-option>
    </ng-select>
    <input   type="file" id="myFile" name="filename" (change)="onFileChange($event,rule)" multiple="false" >
    <button (click)="exportToExcel(rule)">Export</button>
  </ng-container>

  <ng-container *queryInput="let rule; let field=field; let options=options; type: 'inputBtn'">
    <div  class="q-control-size" ng-reflect-ng-class="q-control-size" ng-reflect-ng-switch="string">
      <input  type="text"  style="border: 1px solid; border-color: #ccc; " class="q-input-control ng-untouched ng-pristine ng-valid" ng-reflect-ng-class="q-input-control"  type="text"  [(ngModel)]="rule.value" />
      <input   type="file" id="myFile" name="filename" (change)="onFileChange($event,rule)" multiple="false" >
      <button (click)="exportToExcel(rule)">Export</button>
    </div>
  </ng-container>

</query-builder>

<!-- {{data | json }} -->